import { graphql } from "gql.tada";
import {
  PresetScriptFieldsFragment,
  StepRuleSetFieldsFragment,
} from "./fragments";

export const STEP_RULE_SET_QUERY = graphql(
  `
    query StepRuleSet($tournamentStepId: ID!) {
      stepRuleSet(tournamentStepId: $tournamentStepId) {
        ...StepRuleSetFields
      }
    }
  `,
  [StepRuleSetFieldsFragment],
);

export const PRESET_SCRIPTS_QUERY = graphql(
  `
    query PresetScripts {
      presetScripts {
        ...PresetScriptFields
      }
    }
  `,
  [PresetScriptFieldsFragment],
);

export const BUILTIN_PRESETS_QUERY = graphql(`
  query BuiltinPresets($category: BuiltinPresetCategory) {
    builtinPresets(category: $category) {
      id
      displayName
      description
      category
      supportsPinning
      supportsGroupPinning
      supportsSlotPinning
      parameters {
        name
        type
        required
        defaultValue
        description
      }
    }
  }
`);

export const BUILTIN_PRESET_QUERY = graphql(`
  query BuiltinPreset($id: String!) {
    builtinPreset(id: $id) {
      id
      displayName
      description
      category
      supportsPinning
      supportsGroupPinning
      supportsSlotPinning
      parameters {
        name
        type
        required
        defaultValue
        description
      }
      source
    }
  }
`);

export const PRESET_SCRIPT_QUERY = graphql(
  `
    query PresetScript($id: ID!) {
      presetScript(id: $id) {
        ...PresetScriptFields
      }
    }
  `,
  [PresetScriptFieldsFragment],
);

export const STEP_RULE_SET_STRUCTURE_QUERY = graphql(`
  query StepRuleSetStructure($tournamentStepId: ID!) {
    stepRuleSet(tournamentStepId: $tournamentStepId) {
      id
      validated
      structureTemplate {
        id
        groupTemplates {
          id
          roundTemplates {
            id
          }
        }
      }
    }
  }
`);

export const TOURNAMENT_STEPS_FOR_RULES_QUERY = graphql(`
  query TournamentStepsForRules($tournamentId: ID!) {
    tournamentSteps(tournamentId: $tournamentId) {
      id
      name
      order
    }
  }
`);
